import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BillingAndDeliveryFormContainer } from './BillingAndDeliveryFormContainer.js';

const BillingAndDeliveryForm = (props)=>/*#__PURE__*/ React.createElement(BillingAndDeliveryFormContainer, swcHelpers.extends({}, props))
;

export { BillingAndDeliveryForm };
//# sourceMappingURL=Layout.js.map
